import { render, staticRenderFns } from "./AgentDomain.vue?vue&type=template&id=596a5f65&scoped=true"
import script from "./AgentDomain.vue?vue&type=script&lang=js"
export * from "./AgentDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a5f65",
  null
  
)

export default component.exports